import { isProduction } from '@pn/core/utils/env';
import { pnMapboxLayers } from './pnMapboxLayers';

const compositeSources = [
  'mapbox://sbilston.91j6wu6j',
  'mapbox.mapbox-streets-v8',
  'mapbox.mapbox-terrain-v2',
  'mapbox.mapbox-bathymetry-v2',
  'sbilston.usa_base_map',
];

export const mapboxStyle: mapboxgl.Style = {
  layers: [...pnMapboxLayers],
  sources: {
    'mapbox://mapbox.satellite': {
      type: 'raster',
      url: 'mapbox://mapbox.satellite',
      tileSize: 256,
    },
    composite: {
      type: 'vector',
      url: compositeSources.join(','),
    },
    grids: {
      type: 'vector',
      minzoom: 9,
      maxzoom: 12,
      tiles: [
        isProduction()
          ? 'https://tiles.stackdx.com/grids/{z}/{x}/{y}.pbf'
          : 'https://staging-tiles.stackdx.com/grids/{z}/{x}/{y}.pbf',
      ],
    },
  },
  sprite: 'mapbox://sprites/mapbox/streets-v12',
  glyphs: 'mapbox://fonts/sbilston/{fontstack}/{range}.pbf',
  version: 8,
};

export const builtInLayers = [
  {
    name: 'Hydrology',
    id: 'hydrology',
    sourceLayers: ['water', 'depth'],
  },
  {
    name: 'Land Use',
    id: 'landUse',
    sourceLayers: ['landuse', 'landuse_overlay'],
  },
  {
    name: 'Administrative Borders',
    id: 'admin',
    sourceLayers: ['admin'],
    availableInSatellite: true,
  },
  {
    name: 'Roads',
    id: 'roads',
    sourceLayers: ['road', 'aeroway', 'waterway', 'motorway_junction'],
    availableInSatellite: true,
  },
  {
    name: 'Structures and Buildings',
    id: 'structures',
    sourceLayers: ['structure', 'building'],
  },
  {
    name: 'POI Labels',
    id: 'poiLabels',
    sourceLayers: [
      'poi_label',
      'place_label',
      'airport_label',
      'transit_stop_label',
      'housenum_label',
      'natural_label',
    ],
    availableInSatellite: true,
  },
  {
    name: 'Elevation Contours',
    id: 'elevationContours',
    sourceLayers: ['contour'],
  },
];
